import { Linking, Platform } from 'react-native';

const BASE = 'https://mytenue.com';

const ROUTES_FR = {
  privacy:         '/privacy',
  terms:           '/cgu',
  cgv:             '/cgv',
  mentions:        '/mentions-legales',
  cookies:         '/cookies',
  accountDeletion: '/account-deletion',
  community:       '/community-guidelines',
};
const ROUTES_EN = {
  privacy:         '/privacy-en',
  terms:           '/cgu-en',
  cgv:             '/cgv-en',
  mentions:        '/mentions-legales-en',
  cookies:         '/cookies-en',
  accountDeletion: '/account-deletion-en',
  community:       '/community-guidelines-en',
};

export function getLegalUrl(type, lang = 'fr') {
  const routes = lang === 'fr' ? ROUTES_FR : ROUTES_EN;
  const path = routes[type] || routes.privacy;
  return `${BASE}${path}`;
}

export async function openLegalUrl(type, lang = 'fr') {
  const url = getLegalUrl(type, lang);
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.open(url, '_blank', 'noopener,noreferrer');
      return true;
    }
    const ok = await Linking.canOpenURL(url).catch(() => true);
    if (ok) {
      await Linking.openURL(url);
      return true;
    }
  } catch (e) {
    console.warn('[openLegalUrl]', type, e?.message);
  }
  return false;
}
